export interface StepEntry {
    months: number | null;
    label: string;
}

export const buildSteps = (loanTermMonths: number): StepEntry[] => {
    if (loanTermMonths <= 0) return [{ months: 0, label: '0 years' }];

    const fullYears = Math.floor(loanTermMonths / 12);
    const yearSteps: StepEntry[] = Array.from({ length: fullYears + 1 }, (_, y) => ({
        months: y * 12,
        label: y === 0 ? '0 years' : `${y} year${y > 1 ? 's' : ''}`,
    }));

    const hasPartialYear = fullYears * 12 < loanTermMonths;
    const fullTermStep: StepEntry = {
        months: null,
        label: `Full term (${loanTermMonths} mo)`,
    };

    return hasPartialYear
        ? [...yearSteps, fullTermStep]
        : [...yearSteps.slice(0, -1), fullTermStep];
};
